'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

require('./tabs.scss');

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tabs = function (_React$Component) {
  _inherits(Tabs, _React$Component);

  function Tabs(props) {
    _classCallCheck(this, Tabs);

    var _this = _possibleConstructorReturn(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));

    _this.state = {
      hasArrows: false
    };

    _this.tabsWrapperWith = null;
    _this.tabsWidth = null;
    _this.initialClientXLocation = 0;
    _this.deltaXFromLastTransleRequest = 0;
    _this.deltaXfromLastMoveEvent = 0;

    _this.applyTransformXStyle = _this.applyTransformXStyle.bind(_this);
    _this.saveComponentDimensions = _this.saveComponentDimensions.bind(_this);
    _this.resizeHandler = _this.resizeHandler.bind(_this);

    _this.onMouseDown = _this.onMouseDown.bind(_this);
    _this.onMouseUp = _this.onMouseUp.bind(_this);
    _this.onMouseMove = _this.onMouseMove.bind(_this);
    return _this;
  }

  _createClass(Tabs, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.saveComponentDimensions();

      // eslint-disable-next-line
      this.setState({ hasArrows: this.tabsWrapperWith < this.tabsWidth });

      window.addEventListener('resize', this.resizeHandler, false);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.children.length !== this.props.children.length) {
        // eslint-disable-next-line
        this.setState({ hasArrows: this.tabsWrapperWith < this.tabsWidth });
      }

      this.saveComponentDimensions();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeHandler, false);
    }
  }, {
    key: 'onMouseDown',
    value: function onMouseDown(event) {
      if (this.tabsWrapperWith >= this.tabsWidth) {
        return;
      }

      this.initialClientXLocation = event.clientX || event.touches[0].clientX;
    }
  }, {
    key: 'onMouseMove',
    value: function onMouseMove(event) {
      if (!this.initialClientXLocation) {
        return;
      }

      var clientX = event.clientX || event.touches[0].clientX;

      this.translateTabs(clientX);
    }
  }, {
    key: 'onMouseUp',
    value: function onMouseUp() {
      this.initialClientXLocation = 0;
      this.deltaXFromLastTransleRequest = this.deltaXfromLastMoveEvent;
    }
  }, {
    key: 'saveComponentDimensions',
    value: function saveComponentDimensions() {
      if (!this.tabsWrapperRef) {
        return;
      }

      this.tabsWrapperWith = this.tabsWrapperRef.getClientRects()[0].width;
      this.tabsWidth = this.tabsRef.getClientRects()[0].width;
    }
  }, {
    key: 'translateTabs',
    value: function translateTabs(offset) {
      var maxTranslateValue = this.tabsWidth - this.tabsWrapperWith;
      var potentialTranslateValue = offset - this.initialClientXLocation + this.deltaXFromLastTransleRequest;
      var translateValue = Math.min(Math.max(parseInt(potentialTranslateValue, 10), -maxTranslateValue), 0);
      this.deltaXfromLastMoveEvent = translateValue;

      this.applyTransformXStyle(translateValue);
    }
  }, {
    key: 'applyTransformXStyle',
    value: function applyTransformXStyle(value) {
      this.tabsRef.style.webkitTransform = 'translateX(' + value + 'px)';
      this.tabsRef.style.transform = 'translateX(' + value + 'px)';
    }
  }, {
    key: 'resizeHandler',
    value: function resizeHandler() {
      var areTabsOverflowing = this.tabsWrapperWith < this.tabsWidth;
      if (this.state.hasArrows !== areTabsOverflowing) {
        this.setState({ hasArrows: areTabsOverflowing });
      }

      this.applyTransformXStyle(0);

      this.saveComponentDimensions();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          activeColor = _props.activeColor,
          className = _props.className,
          children = _props.children,
          border = _props.border,
          size = _props.size,
          props = _objectWithoutProperties(_props, ['activeColor', 'className', 'children', 'border', 'size']);

      var wrapperClasses = (0, _classnames2.default)('tabs-wrapper', border && 'tabs-wrapper--border-' + border, className);

      var classes = (0, _classnames2.default)('tabs', 'tabs--background-transparent', 'tabs--' + size, activeColor && 'tabs--active-color-' + activeColor);

      var hasArrows = this.state.hasArrows;

      return _react2.default.createElement(
        'div',
        {
          className: wrapperClasses,
          onMouseDown: this.onMouseDown,
          onMouseMove: this.onMouseMove,
          onMouseUp: this.onMouseUp,
          onMouseLeave: this.onMouseUp,

          onTouchStart: this.onMouseDown,
          onTouchMove: this.onMouseMove,
          onTouchEnd: this.onMouseUp
        },
        hasArrows && _react2.default.createElement(
          'div',
          { className: 'tabs__arrow tabs__arrow--start', onClick: function onClick() {
              return _this2.translateTabs(40);
            } },
          _react2.default.createElement(_icon2.default, { name: 'arrow-left-thin', size: '10' })
        ),
        _react2.default.createElement(
          'div',
          {
            className: 'tabs_container',
            ref: function ref(div) {
              _this2.tabsWrapperRef = div;
            }
          },
          _react2.default.createElement(
            'ul',
            _extends({
              className: classes,
              ref: function ref(div) {
                _this2.tabsRef = div;
              }
            }, props),
            children
          )
        ),
        hasArrows && _react2.default.createElement(
          'div',
          { className: 'tabs__arrow tabs__arrow--end', onClick: function onClick() {
              return _this2.translateTabs(-40);
            } },
          _react2.default.createElement(_icon2.default, { name: 'arrow-right-thin', size: '10' })
        )
      );
    }
  }]);

  return Tabs;
}(_react2.default.Component);

Tabs.propTypes = {
  activeColor: _propTypes2.default.oneOf(['romantic', 'sky', 'dark']),
  border: _propTypes2.default.oneOf(['none', 'light']),
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  size: _propTypes2.default.oneOf(['small', 'medium', 'large'])
};

Tabs.defaultProps = {
  activeColor: 'sky',
  size: 'medium'
};

exports.default = Tabs;